<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-30 15:53:17
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-01 11:28:17
-->
<template>
  <div :class="['comment'].includes($route.query.type) ? 'articleAndQaWrapper articleAndQaWrapper_comment' : 'articleAndQaWrapper'">
    <div v-title :data-title="title"></div>
    <van-sticky v-if="['up', 'collect', 'viewHistory', 'comment', 'focus'].includes($route.query.type)">
      <van-tabs v-model="active" @change="handleTabChange" sticky>
        <van-tab v-for="item in tabList" :key="item.id">
          <template #title>{{item.name}}</template>
        </van-tab>
      </van-tabs>
    </van-sticky>
    <div v-if="['qa'].includes($route.query.type)" class="realname-tip">仅保存实名发布数据</div>
    <div :class="['qa'].includes($route.query.type) || +active ? '' : 'article-list'">
      <van-pull-refresh
        v-if="articleList.length || loading"
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功">
        <van-list
          v-if="['comment'].includes($route.query.type)"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          style="padding-bottom:50px;"
        >
          <div v-for="(item, index) in articleList" :key="index">
            <div class="list-item">
              <div class="comment-content">
                <span>{{item.level > 1 ? '回复' : '评论'}}{{active ? '畅聊' : '文章'}}</span>
                【<span @click="handleLinkDetail(item)" class="inner-box">
                {{item.title.slice(0, 34)}}
                {{item.title.length > 35 ? '...' : ''}}
                </span>】
                <span v-if="item.level > 1">的评论“<span class="comment-content-html">
                  {{item.replyContent.slice(0, 19)}}
                  {{item.replyContent.length > 20 ? '...' : ''}}
                </span>”：</span>
                <span v-else>：</span>
              </div>
              <div class="comment-content-html" v-html="item.commentContent"></div>
              </div>
          </div>
        </van-list>
        <van-list
          v-else-if="['focus'].includes($route.query.type) && !active"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          style="padding-bottom:50px;"
        >
          <div v-for="(item, index) in articleList" :key="index">
            <div class="user-item">
              <div style="display:flex;">
                <van-image
                  @click="handlePersonal(item.followId)"
                  round
                  width="1rem"
                  height="1rem"
                  class="item-avatar"
                  :src="item.avatar"
                />
                <div class="item-info" @click="handlePersonal(item.followId)">
                  <div>
                    <span>{{item.erpName}}</span>
                  </div>
                  <div class="label item-org">{{item.erp}}</div>
                </div>
              </div>
              <van-button
                @click="handleAttention(item)"
                class="attentionBtn"
                size="small"
                :type="!fansType ? 'default' : item.isFollowStatus ? 'default' : 'info'">
                {{!fansType ? '已关注' : item.isFollowStatus ? '已关注' : '关 注'}}
              </van-button>
            </div>
          </div>
        </van-list>
        <van-list
          v-else
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          style="padding-bottom:50px;"
        >
        <div v-for="(item, index) in articleList" :key="index">
          <BbsCard
            v-if="item.type === 1"
            :rowData="item"
            @refresh="handleRefresh"
          />
          <div v-else class="list-item">
            <div  class="top">
            <div class="avatar">
              <van-image
                @click="handlePersonal(item.userId)"
                round
                width="1rem"
                height="1rem"
                :src="item.userIconUrl"
                style="flex-shrink:0"
              />
              <FansPendant v-if="item.userId" :userId="item.userId"/>
            </div>
            <div class="info">
            <div class="name" @click="handlePersonal(item.userId)">
              <span>{{item.userName}}
                <span v-if="item.organizationFullName" class="inner-box" style="font-size:12px;color:#606266;">{{formatOrg(item.organizationFullName)}}</span>
              </span>
            </div>
            <div class="org">
                <span class="time">{{item.createTime}}</span>
            </div>
          </div>
        </div>
            <div class="title" v-if="!active && !['qa'].includes($route.query.type)">
              <div @click="handleLinkDetail(item)" class="inner-box">
                {{item.title}}
              </div>
            </div>
            <div @click="handleLinkDetail(item)" class="middle">
              <div class="content">
                {{item.info || item.contentText}}
              </div>
              <van-image
                v-if="item.firstImgUrl"
                :src="item.firstImgUrl"
                lazy-load
                fit="cover"
                class="first-img"
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>
            <div style="display:flex;justify-content:space-between;color:#606266">
              <span>{{item.createTime}}</span>
              <div>
                <span style="margin-right:10px;">
                  <!-- <van-icon name="chat-o" /> -->
                  <img style="width: 12px;height: 10px" src="../../assets/huifu.png"/>
                  {{item.totalReplyNum}}
                </span>
                <span>
                  <van-icon name="eye-o" />
                  {{item.viewNum}}
                </span>
              </div>
              <!-- <span></span> -->
            </div>
          </div>
          <!-- <van-divider /> -->
        </div>
        </van-list>
      </van-pull-refresh>
      <van-empty
        v-else
        description="暂无数据" />
    </div>
  </div>
</template>

<script>
import api from '../../api'
import { mapActions, mapState } from 'vuex';
import FansPendant from '../../components/fansPendant.vue';
import BbsCard from './../article/components/bbsCard.vue';

export default {
  components: {
    FansPendant,
    BbsCard
  },
  data() {
    return {
      pageParams: {
        page: 1,
        pageSize: 10
      },
      active: 0,
      articleList: [],
      loading: false,
      finished: false,
      refreshing: false,
      fansType: this.$route.query.type === 'fans',
      title: ''
    }
  },
  computed: {
    ...mapState(['userInfo']),
    tabList() {
      if (['focus'].includes(this.$route.query.type)) {
        return [
          { id: 0, name: '用户' },
          { id: 2, name: '畅聊' }
        ]
      }
      return [
        { id: 1, name: '文章' },
        { id: 2, name: '畅聊' }
      ]
    },
  },
  created() {
    this.fetchArticleList()
    this.handleBack()
  },
  methods: {
    ...mapActions(['updateUserInfoList']),
    formatOrg(val) {
      if (val) {
        let ary = val.split('-')
        let filterAry = ary.slice(1, 3)
        return filterAry.join('-')
      }
    },
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    },
    handleBack() {
      const _this = this
      let options = {
          disabled: true,
          callback: function() {
            _this.$router.go(-1)
          }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    handleRefresh(val, type) {
      console.log(val)
      if (val) {
        if (type === 'vote') {
          this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, {...val})
          }
          return item
        })
          return;
        }
        if (type === 'share') {
          this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { sharedNum: val.sharedNum })
          }
          return item
        })
          return;
        }
        let up
        let upNum
        if (val.isUp === '踩') {
          up = val.isUp === '踩' ? -1 : 1
          upNum = val.upNum
        } else {
          up = val.isUp === 1 ? -1 : 1
          upNum = val.isUp === 1 ? val.upNum - 1 : val.upNum + 1 
        }
        this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { isUp: up, upNum })
          }
          return item
        })
      } else {
        this.fetchArticleList()
      }
    },
    fetchArticleList() {
      this.loading = true
      const { id, type } = this.$route.query
      let apiUrl = api.getUserPostList
      let typeParam = 0
      switch(type) {
        case 'article':
          apiUrl = api.getUserPostList
          typeParam = 0
          this.title = !this.$route.query?.id || this.$route.query?.id === this.userInfo?.id ? '我的文章' : `${this.$route.query.userName || 'Ta'}的文章`
          break
        case 'qa':
          apiUrl = api.getUserPostList
          typeParam = 1
          this.title = !this.$route.query?.id || this.$route.query?.id === this.userInfo?.id ? '我的畅聊' : `${this.$route.query?.userName || 'Ta'}的畅聊`
          break
        case 'up':
          apiUrl = api.getUpPostList
          typeParam = this.active
          this.title = '我的点赞'
          break
        case 'comment':
          apiUrl = api.getCommentPostList
          typeParam = this.active
          this.title = '我的评论'
          break
        case 'collect':
          apiUrl = api.getCollectPostList
          typeParam = this.active
          this.title = '我的收藏'
          break
        case 'viewHistory':
          apiUrl = api.getViewHistory
          typeParam = this.active
          this.title = '浏览历史'
          break
        case 'focus':
          apiUrl = api.getUserFollowList;
          typeParam = +this.active === 1 ? 2 : 0;
          this.title = '我关注的';
          break;
      }
      apiUrl({
        ...this.pageParams,
        userId: id 
      }, typeParam).then(res => {
        this.loading = false
        const { code, data, totalCount } = res
        if (this.refreshing) {
          this.refreshing = false
        }
        if (code === 200) {
          if (this.pageParams.page > 1) {
            this.articleList = this.articleList.concat(data)
          } else {
            this.articleList = data
          }
          if (this.articleList.length >= totalCount) {
            this.finished = true
          }
          const userIds = data?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
        }
      })
    },
    onLoad() {
      this.pageParams.page++
      this.fetchArticleList()
    },
    onRefresh() {
      this.finished = false
      this.pageParams.page = 1 
      this.fetchArticleList()
    },
    handleAttention(item) {
      if (!this.fansType) {
        api.cancelFollow(item.followId).then(() => {
          this.fetchArticleList()
        })
      } else {
        api.follow(item.fansId).then(() => {
          this.fetchArticleList()
        })
      }
    },
    handleLinkDetail(item) {
      this.$router.push({
        name: item.type === 1 ? 'bbsDetail' : 'articleDetail',
        params: { id: ['comment'].includes(this.$route.query.type) ? item.postId : item.id }
      })
    },
    handleTabChange() {
      this.finished = false
      this.pageParams.page = 1 
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.articleList = []
      this.fetchArticleList()
    }
  }
}
</script>

<style lang="less" scoped>
.top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.org {
  font-size: 14px;
  width: 100%;
  display: inline-flex;
  font-size:12px;
  color:#606266;
}
.name {
  color: #232930;
  text-align: left;
}
.time {
  margin-right: 20px;
}

.info {
  margin-left: 6px;
  color: #606266;
  display: flex;
  flex: 1;
  font-size: 14px;
  flex-direction: column;
  align-items: self-start;
}
.realname-tip {
  padding: 8px 8px 0 8px;
  color: #848484;
}
.articleAndQaWrapper_comment {
  text-align: left;
}
.articleAndQaWrapper {
  min-height: 100vh;
  z-index: 10;
  font-size: 14px;
  /deep/ .van-pull-refresh {
    user-select: text;
    -webkit-user-select: text;
  }
  .article-list {
    padding: 0 10px;
  }
  .item-info {
    margin-left: 10px;
    text-align: left;
  }
  .item-avatar {
    flex-shrink: 0;
  }
  .ellip {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 85%;
  }
  .label {
    color: #606266;
  }
  .item-org {
    font-size: 12px;
  }
  /deep/ .van-divider {
    margin: 10px;
  }
  .org {
    font-size: 14px;
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    font-size:12px;
    color:#606266;
  }
  .inner-box {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .name {
    color: #232930;
    display: inline-flex;
    align-items: center;
    width: 100%;
  }
  .middle {
    .content {
      text-align: left;
      margin-bottom: 8px;
      font-size: 14px;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }
  .first-img {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
    background-color: #f0f2f5;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    /deep/ img {
      object-fit: cover;
    }
  } 
  .title {
    text-align: left;
    font-size: 16px;
    // color: #2695F1;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .list-item {
    background:#fff;
    margin-top: 10px;
    padding: 15px;
    border-radius: 4px;
  }
  .user-item {
    background:#fff;
    margin-top: 8px;
    padding: 8px 15px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.comment-content {
  word-break: break-all;
  .inner-box {
    color: #2695f1;
     white-space: normal;
  }
  
}
.comment-content-html {
    font-size: 13px;
    color: #606266;
  }
  .avatar {
    position: relative;
  }
  .attentionBtn {
    // width: 54px;
    padding: 0 12px;
    height: 24px;
    border-radius: 12px;
    // background: #4783F7;
  }
</style>
